var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h512v341.3H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#56AF35",
    d: "M0 0h512v170.7H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "m0 341.3 512-170.7L0 0v341.3z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffc945"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.7 231.5c33.6 0 60.8-27.2 60.8-60.8s-27.2-60.8-60.8-60.8-60.8 27.2-60.8 60.8 27.2 60.8 60.8 60.8zm0 24.3c-47 0-85.2-38.1-85.2-85.2s38.1-85.2 85.2-85.2 85.2 38.1 85.2 85.2-38.2 85.2-85.2 85.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 148.3,
    r: 17.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.9,
    cy: 158.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.7,
    cy: 135.2,
    r: 17.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.5,
    cy: 172.7,
    r: 17.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.9,
    cy: 182.8,
    r: 17.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.5,
    cy: 198,
    r: 17.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.9,
    cy: 205.2,
    r: 17.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEr);
export default __webpack_public_path__ + "static/media/ER.264488a4.svg";
export { ForwardRef as ReactComponent };